// extracted by mini-css-extract-plugin
module.exports = {"sideTabs":"SideTabs_sideTabs__25Zh6","links":"SideTabs_links__2NoQ1","body":"SideTabs_body__1ZNe6"};